export default {"src":"/_next/static/image/public/images/ic_checkbox_red.094141c5c7cf9eeca5da16cb15901f39.svg","height":20,"width":20};